<template lang="html">
  <section class="demo">

    <div style="width: 100%; display: flex; flex-direction: column">
      <h3>Setup</h3>

      <p>The first time you launch the app, you will be asked to provide some Android permissions to the app for it to be able to function properly.</p>

      <p>These permissions include:</p>
      <ul class="Vlt-list Vlt-list--simple">
        <li>
          Standard Permissions
          <ul class="Vlt-list Vlt-list--simple">
            <li>Contacts (for loading your phone’s contact so that we can make calls and cross-check against app users)</li>
            <li>Microphone (for voice calls)</li>
            <li>Phone (for making PSTN calls)</li>
            <li>Storage (for getting files for attachment support)</li>
          </ul>
        </li>
        <li>
          Additional Permissions
          <ul class="Vlt-list Vlt-list--simple">
            <li>Display over other apps (for displaying the ringing screen upon voice call received when the app is not in foreground)</li>
          </ul>
        </li>
      </ul>
    </div>

  </section>

</template>

<script lang="js">
  export default  {
    name: 'demo',
    components: {
    },
    props: {
      nexmo:{
          type: Object,
          required: false
      }
    },
}
</script>

<style scoped lang="scss">
</style>